<template>
  <div class="nuttrema-status-tag" :class="[`status-${status}`]">
    <div class="nuttrema-status-tag__title">
      <span>{{ $t(`label.${status}`) }}</span>
    </div>
    <div class="nuttrema-status-tag__status-holder">

      <div class="nuttrema-status-tag__status">
        <el-popover
           ref="nuttrema-status-tag-popover"
           placement="bottom"
           width="300"
           trigger="hover"
           popper-class="el-popover--status"
          :title="$t(`label.${status}`)"
          :open-delay="500"
          :content="$t(`label.status_${related}_${status}_help`)">
        </el-popover>
        <span v-popover:nuttrema-status-tag-popover class="status__letter">{{ $t(`label.${status}`) | first-upper }}</span>
      </div>

      <div v-if="link" class="nuttrema-status-tag__status is-link" @click="onChangeStatus">
        <span>
          <el-tooltip class="item" effect="dark" :content="$t('label.status_details')" placement="top">
            <i class="fas fa-angle-right"></i>
          </el-tooltip>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'nuttrema-status-tag',
  props: {
    status: {
      type: String,
      required: false,
      default: 'draft',
    },
    related: {
      type: String,
      required: false,
      default: null,
    },
    id: {
      required: false,
      default: null,
    },
    link: {
      required: false,
      default: null,
    },
    available: {
      required: false,
      default: () => ['draft', 'active', 'inactive'],
    },
    delay: {
      type: Number,
      required: false,
      default: 500,
    },
  },
  data() {
    return {
      timeout: false,
      show: false,
    };
  },
  methods: {
    onChangeStatus() {
      this.$router.push(this.link);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "./nuttrema-status-colors";

  .nuttrema-status-tag {
    flex-grow: 1;
    display: flex;
    position: relative;
    flex-direction: column;

    .nuttrema-status-tag__title {
      height: 21px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      > span {
        font-size: 0.8rem;
        text-transform: uppercase;
      }

      > a {
        font-size: 0.75rem;
        color: $color-text;
        padding-right: 0.25em;
        i { padding-left: 0.25em; }
        &:hover {
          color: darken($color-text, 10%);
        }
      }
    }

    .nuttrema-status-tag__status-holder {
      display: flex;
      border-radius: 4px;
      height: 15px;
      line-height: 1rem;
      overflow: hidden;
      background-color: $color-gray-light;
      text-shadow: 0 -1px 0 rgba(0,0,0,0.15);

      .nuttrema-status-tag__status {
        flex-grow: 1;
        display: flex;
        justify-content: center;

        transition: all 0.5s;

        .status__letter {
          width: 100%;
          text-align: center;
        }

        &.is-link {
          position: absolute;
          height: 15px;
          right: 0;
          flex-grow: 0;
          display: none;
          visibility: hidden;
          border-top-right-radius: 4px;
          border-bottom-right-radius: 4px;
          border-left: 1px solid darken($color-gray-light, 5%);
        }

        > span, > a {
          font-weight: 600;
          font-size: 0.75rem;
          color: $color-white;
        }


        &.is-active {
          flex-grow: 2;
          border-right: none;
        }

        &:last-child {
          border-right: none;
        }
      }

      &:hover, &:focus {
        .nuttrema-status-tag__status {
          cursor: pointer;
          &.is-link {
            opacity: 1;
            width: 1.5em;
            display: flex;
            visibility: visible;
          }
        }
      }

    } // end ~ nuttrema-status-tag__status-holder

    @mixin status-color($color) {
      .nuttrema-status-tag__status {
        background-color: $color;
        &.is-link {
          background-color: lighten($color, 10%);
        }
      }
    }

    &.status-draft {
      @include status-color($color-status-draft);
    }

    &.status-active {
      @include status-color($color-status-active);
    }

    &.status-inactive {
      @include status-color($color-status-inactive);
    }

    &.status-pending {
      @include status-color($color-status-pending);
    }

    &.status-blocked {
      @include status-color($color-status-blocked);
    }

    &.status-archived {
      @include status-color($color-status-archived);
    }

    &.status-sent {
      @include status-color($color-status-sent);
    }

    &.status-accepted {
      @include status-color($color-status-accepted);
    }

    &.status-canceled {
      @include status-color($color-status-canceled);
    }

    &.status-ready {
      @include status-color($color-status-ready);
    }

    &.status-current {
      @include status-color($color-status-current);
    }

    &.status-hold {
      @include status-color($color-status-hold);
    }

    &.status-unsent {
      @include status-color($color-status-unsent);
    }

    &.status-seen {
      @include status-color($color-status-seen);
    }

    &.status-confirmed {
      @include status-color($color-status-confirmed);
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/ui/label/nuttrema-status-tag.vue